module.exports = __webpack_public_path__ + "img/app-qy2.bd0fdb4c.png";